import InfoCard from './info-card'
export default InfoCard
